
import { UPDATE_PASSWORD, GET_USER_PROFILE, SET_USER_PROFILE, SET_BUSINESS_PROFILE, UPDATE_USER_PROFILE } from './actionTypes';

export const getUserProfile = () => {
    return {
        type: GET_USER_PROFILE,
    };
};
export const setUserProfile = data => {
    return {
        type: SET_USER_PROFILE,
        payload: data
    };
};


export const setBusinessProfile = data => {
    return {
        type: SET_BUSINESS_PROFILE,
        payload: data
    };
};
export const updateUserProfile = data => {
    return {
        type: UPDATE_USER_PROFILE,
        payload: data
    };
};
export const updatePassword = data => {
    return {
        type: UPDATE_PASSWORD,
        payload: data
    };
};

